import React from 'react';

const HuntHeader = ({ title = 'JG Trailblazer Treasure Hunts' }) => (
  <span className="display-5 fw-bold text-primary text-shadow-custom d-flex align-items-center gap-2">
    <img
      src="https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1664565843/Images/JOEGALAXYDopeGalaxyLogooriginal_tecmer.png"
      alt="JG Logo"
      style={{ height: 70, width: 'auto', marginRight: 12 }}
      className="me-2"
    />
    {title}
  </span>
);

export default HuntHeader;
